import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class BreakpointService {
    private readonly isHandset$: Observable<boolean> = this.breakpointObserver
        .observe(Breakpoints.HandsetPortrait)
        .pipe(map((result) => result.matches))

    constructor(private readonly breakpointObserver: BreakpointObserver) {}

    observeHandset(): Observable<boolean> {
        return this.isHandset$
    }
}
